export interface SkeletonProps {
  className?: string;
  /** Number of placeholder rows to render. Defaults to 1. */
  rows?: number;
}

/**
 * Loading placeholder (ui-guidelines.md section 14). Each row is
 * `role="presentation" aria-hidden="true"` because the loading state itself
 * is announced separately (e.g. a live-region "Loading users..." message),
 * not by the placeholder shapes.
 *
 * Shimmer tone comes from the `--skeleton` theme token, so it follows the
 * active `data-theme`: the guideline's light-surface value (§14, `#F0F5FA`) in
 * light, and the raised admin surface in dark.
 */
export function Skeleton({ className = '', rows = 1 }: SkeletonProps) {
  return (
    <>
      {Array.from({ length: rows }, (_, index) => (
        <div
          key={index}
          role="presentation"
          aria-hidden="true"
          className={`animate-pulse rounded-lg bg-skeleton ${className}`.trim()}
        />
      ))}
    </>
  );
}
